import { useCalendarScroll } from "components/Dashboard/DoctorDashboard/views/one-one-sessions/components/layout/components/calendar-view/contexts/calendar-scroll-context";
import useId from "hooks/useId";
import { useEffect, useMemo } from "react";
import OverlayTrigger, {
  OverlayTriggerProps,
} from "components/overlay-trigger/OverlayTrigger";
import { useCalendarFreeze } from "components/Dashboard/DoctorDashboard/views/one-one-sessions/components/layout/components/calendar-view/contexts/calendar-freeze-context";
import { useCalendarTime } from "components/Dashboard/DoctorDashboard/views/one-one-sessions/contexts/CalendarTimeContext";

type Props = OverlayTriggerProps & { freezeOnShow?: boolean };
const CalendarOverlayTrigger = ({
  freezeOnShow = false,
  onToggle,
  ...props
}: Props) => {
  const { registerOverlay, unregisterOverlay } = useCalendarScroll();
  const { registerFreezeId, unregisterFreezeId } = useCalendarFreeze();

  const id = useId();

  useEffect(() => {
    return () => {
      unregisterFreezeId(id);
      unregisterOverlay(id);
    };
  }, [unregisterFreezeId, unregisterOverlay, id]);

  // calendar / time range type
  const { currentTimeRangeType } = useCalendarTime();
  // for day view it should be auto, for weekly view it should be on the right
  const popperPlacement = useMemo(
    () => (currentTimeRangeType === "day" ? "auto" : "right"),
    [currentTimeRangeType],
  );

  return (
    <OverlayTrigger
      trigger={"focus"}
      placement={popperPlacement}
      flip={true}
      {...props}
      onToggle={(nextShow: boolean) => {
        console.log("onToggle", { nextShow });
        if (nextShow) {
          registerOverlay(id);
          if (freezeOnShow) {
            registerFreezeId(id);
          }
        } else {
          unregisterOverlay(id);
          if (freezeOnShow) {
            unregisterFreezeId(id);
          }
        }
        if (onToggle) {
          return onToggle(nextShow);
        }
      }}
    />
  );
};

export default CalendarOverlayTrigger;
